import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getSettings } from "../services/contentService";

const DEFAULTS = {
  whatsapp: "919321133580",
  phone: "919321133580",
  instagram:
    "https://www.instagram.com/smilaxdentalclinics?igsh=MWdtdDN6MG9jcXgyOQ==",
};

// strip everything except digits for tel:/wa.me links
const digits = (v) => (v || "").replace(/[^0-9]/g, "");

const FloatingButtons = () => {
  const [contact, setContact] = useState(DEFAULTS);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const s = await getSettings();
      if (mounted && s) {
        setContact({
          whatsapp: digits(s.whatsapp) || DEFAULTS.whatsapp,
          phone: digits(s.phone) || DEFAULTS.phone,
          instagram: s.instagram || DEFAULTS.instagram,
        });
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const whatsappNumber = contact.whatsapp;
  const phoneNumber = contact.phone;
  const instagramUrl = contact.instagram;

  return (
    <>
      {/* 1. DESKTOP FLOATING STACK */}
      <div className="floating-desktop-stack d-none d-md-flex">
        <motion.a
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noreferrer"
          className="float-btn whatsapp-btn"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
          whileHover={{ scale: 1.1, y: -5 }}
        >
          <i className="fa-brands fa-whatsapp"></i>
          <span className="tooltip-text">WhatsApp</span>
        </motion.a>

        <motion.a
          href={`tel:${phoneNumber}`}
          className="float-btn call-btn"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2 }}
          whileHover={{ scale: 1.1, y: -5 }}
        >
          <i className="fa-solid fa-phone"></i>
          <span className="tooltip-text">Call Us</span>
        </motion.a>

        <motion.a
          href={instagramUrl}
          target="_blank"
          rel="noreferrer"
          className="float-btn insta-btn"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
          whileHover={{ scale: 1.1, y: -5 }}
        >
          <i className="fa-brands fa-instagram"></i>
          <span className="tooltip-text">Instagram</span>
        </motion.a>
      </div>

      {/* 2. FULL-WIDTH SQUARE MOBILE NAV */}
      <div className="premium-mobile-nav d-flex d-md-none">
        <div className="nav-dock-square">
          <a href={`tel:${phoneNumber}`} className="mobile-nav-item">
            <div className="nav-icon-wrapper">
              <i className="fa-solid fa-phone-volume"></i>
            </div>
            <span>Call</span>
          </a>

          <a href="/appointment" className="mobile-nav-item center-cta">
            <div className="cta-circle">
              <i className="fa-solid fa-calendar-check"></i>
            </div>
            <span className="cta-label">Book Now</span>
          </a>

          <a href={`https://wa.me/${whatsappNumber}`} className="mobile-nav-item">
            <div className="nav-icon-wrapper wa-glow">
              <i className="fa-brands fa-whatsapp"></i>
            </div>
            <span>WhatsApp</span>
          </a>
        </div>
      </div>

      <style>{`
        /* --- DESKTOP STACK FIXES --- */
        .floating-desktop-stack {
          position: fixed; 
          right: 30px; 
          bottom: 40px;
          display: flex; 
          flex-direction: column; 
          gap: 15px; 
          z-index: 999999;
        }

        .float-btn {
          width: 55px; 
          height: 55px; 
          border-radius: 50%;
          display: flex; 
          align-items: center; 
          justify-content: center;
          color: #fff; 
          font-size: 24px; 
          text-decoration: none !important;
          box-shadow: 0 10px 25px rgba(0,0,0,0.2); 
          position: relative; 
          transition: all 0.3s ease;
        }

        .whatsapp-btn { background: #25D366; }
        .call-btn { background: #0f172a; }
        .insta-btn { background: linear-gradient(45deg,#feda75,#fa7e1e,#d62976,#962fbf,#4f5bd5); }

        /* Tooltip refinement to prevent it showing incorrectly */
        .tooltip-text {
          position: absolute; 
          right: 75px; 
          background: #1e293b; 
          color: #fff;
          padding: 6px 14px; 
          border-radius: 8px; 
          font-size: 13px; 
          font-weight: 600;
          opacity: 0; 
          visibility: hidden;
          pointer-events: none; 
          transition: all 0.3s ease; 
          white-space: nowrap;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .float-btn:hover .tooltip-text { 
          opacity: 1; 
          visibility: visible;
          right: 65px; 
        }

        /* --- MOBILE NAV --- */
        .premium-mobile-nav {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          z-index: 999999;
        }

        .nav-dock-square {
          background: rgba(15, 23, 42, 0.98);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          width: 100%;
          height: 75px;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          box-shadow: 0 -5px 25px rgba(0, 0, 0, 0.4);
          padding-bottom: env(safe-area-inset-bottom);
        }

        .mobile-nav-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none !important;
          color: rgba(255, 255, 255, 0.6);
          flex: 1;
          transition: 0.2s;
        }

        .mobile-nav-item span {
          font-size: 10px;
          font-weight: 700;
          margin-top: 4px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .nav-icon-wrapper { font-size: 19px; color: #fff; }

        .center-cta {
          position: relative;
          top: -18px;
        }

        .cta-circle {
          width: 60px;
          height: 60px;
          background: #3b82f6;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          box-shadow: 0 8px 20px rgba(59, 130, 246, 0.5);
          border: 4px solid #0f172a;
        }

        .cta-label {
          color: #3b82f6 !important;
          font-weight: 800 !important;
        }

        .wa-glow { color: #25D366; }

        @media (max-width: 767px) {
          body { padding-bottom: 75px !important; }
        }
      `}</style>
    </>
  );
};

export default FloatingButtons;